import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const FreshworksModal = (props) => {
    const [apikey, setApikey] = useState("");
    const [errorApikey, setErrorApikey] = useState(false);
    const [orgurl, setOrgUrl] = useState("");
    const [errorOrgUrl, setErrorOrgUrl] = useState(false);

    const handleSubmit = async (values) => {
        if (!apikey) {
            setErrorApikey(true);
        }

        // normalize url to https://rafiki.myfreshworks.com/
        let temp = normalizeURL(orgurl);
        let provider = {
            accessToken: apikey,
            url: temp,
            provider: "freshworks",
            service: "CRM",
        }
        try {
            let response = await postJsonAxiosService("freshworks/webhook/validate", {provider: provider});
            console.log("Freshworks integration response:", {
                status: response?.status,
                data: response?.data,
                headers: response?.headers,
            });
            if (response) {

                if (response.data === "Incorrect API key") {
                    toastService.error("Invalid Api Key");
                } else {
                    toastService.info("Freshworks Integrated");
                    setTimeout(() => window.location.reload(), 1500);
                }
            }
        } catch (e: any) {
            console.error("Freshworks integration error:", {
                message: e?.message,
                code: e?.code,
                status: e?.response?.status,
                data: e?.response?.data,
                responseHeaders: e?.response?.headers,
                isAxiosError: e?.isAxiosError,
                stack: e?.stack,
            });
            const serverMessage = typeof e?.response?.data === "string" ? e.response.data : e?.response?.data?.message;
            toastService.error("Error while updating integration" + (serverMessage ? ": " + serverMessage : ""));
        }
    };

    function normalizeURL(input) {
        var pattern = /^(https?:\/\/)([^\/]+)(.*)$/;
        var matches = input.match(pattern);
        if (!matches) {
            input = 'https://' + input;
        } else {
            if (!matches[1]) {
                input = 'https://' + input;
            }
            if (!matches[3].endsWith('/')) {
                input = input + '/';
            }
        }
        if (input.endsWith('crm/sales/') || input.endsWith('crm/sales')) {
            input = input.split("crm/sales")[0];
        }
        if (!input.endsWith('/')) {
            input = input + '/';
        }
        return input;
    }
    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Freshworks CRM Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <label>Api Key</label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter Api Key"
                               value={apikey}
                               onChange={(e) => {
                                   setApikey(e.target.value);
                                   setErrorApikey(false);
                               }}
                        />
                        {errorApikey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter Api Key
                            </div>
                        ) : null}
                    </div>
                    <div>
                    </div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124", marginTop: 20}}>
                        <label>Organization Url</label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter Organization Url eg. https://getrafiki.myfreshworks.com/"
                               value={orgurl}
                               onChange={(e) => {
                                   setOrgUrl(e.target.value);
                                   setErrorOrgUrl(false);
                               }}
                        />
                        {errorApikey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter Organization Url in format "https://domain.myfreshworks.com/"
                            </div>
                        ) : null}
                    </div>

                </div>

            </ModalBody>
            <ModalFooter style={{border: "none", padding: "0px 0px 10px 30px"}}>
                <Button className={"btn-typography-secondary"} onClick={props.toggle}>
                    Cancel
                </Button>{" "}
                <Button className={"btn-typography-primary"} onClick={handleSubmit}>
                    Authorize
                </Button>{" "}
            </ModalFooter>
        </div>
    )
};

export default FreshworksModal;
